import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import { isLoggedIn, isSuperAdmin } from '../../../reducers/auth';
import { useLocation, useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import ItemService from '../../../services/item.service';
import CatalogService from '../../../services/catalog.service';
import AdminService from '../../../services/admin.service';
import Spinner from "react-bootstrap/Spinner";
import LogoButton from "../../LogoButton";
import { ArrowClockwise } from 'react-bootstrap-icons';
import AdminImageGallery from '../AdminImageGallery';
import { resolveImageUrl, resolveSwatchUrl } from '../../../utils/imageUrl';

const PRICING_TYPES = {
  FLAT: 1,
  QUANTITY: 2,
  BILL_LATER: 3
};

const ProductDetails = () => {
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  let navigate = useNavigate();

  //  const catalogItem = useSelector(selectCatalogItem);
  const [catalogItem, setCatalogItem] = useState(null);
  //  const otherProductItems = useSelector(selectOtherCatalogItems);
  const [imgSrc, setImgSrc] = useState(null);
  const [imgSrcBack, setImgSrcBack] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);
  const [currentPrice, setCurrentPrice] = useState(null);
  const [decorations, setDecorations] = useState([]);
  const [selectedDecoration, setSelectedDecoration] = useState([]);
  const [currentDragColor, setCurrentDragColor] = useState(null);
  const [currentColor, setCurrentColor] = useState(null);
  const [currentSize, setCurrentSize] = useState(null);
  const [currentDragColorSizes, setCurrentDragColorSizes] = useState([]);
  const location = useLocation();
  const loginStatus = useSelector(isLoggedIn);
  const [show, setShow] = useState(false);
  const [addSizes, setAddSizes] = useState("");
  const [imageModalShow, setImageModalShow] = useState(false);
  const [content, setContent] = useState(null);
  const handleSizeModalClose = () => setShow(false);
  const [availableColors, setAvailableColors] = useState(null);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedLogos, setSelectedLogos] = useState([]);
  const [showSpinner, setShowSpinner] = useState(false);
  const [colorUpdateSpinner, setColorUpdateSpinner] = useState(false);
  const [quantityPrices, setQuantityPrices] = useState([]);
  const [updatedLogos, setUpdatedLogos] = useState("");
  const [currentDecorations, setCurrentDecorations] = useState(null);
  const [currentLogoPrice, setCurrentLogoPrice] = useState(0);
  const [inventoryLoading, setInventoryLoading] = useState(false);
  const [inventoryMessage, setInventoryMessage] = useState(null);
  const [removing, setRemoving] = useState(false);
  const [removeFlash, setRemoveFlash] = useState(null);
  const [loadError, setLoadError] = useState(null);
  const superAdmin = useSelector(isSuperAdmin);
  const primaryItem = catalogItem?.[0] || null;


  const selectedLogo = (e) => {
    console.log("Selected Logo", e.target.value);
    setSelectedDecoration(e.target.value);
  }

  const updateColors = async () => {
    setColorUpdateSpinner(true);
    try {
      await AdminService.updateSanmarColors(location.state.productId);

      let item = await ItemService.getItemNonCatalog(location.state.productId);
      const rows = Array.isArray(item?.item) ? item.item : [];
      if (!rows[0]) {
        setLoadError("Product not found after color update.");
        return;
      }
      setCatalogItem(rows);
      setDecorations(item.decorations);
      if (item.decorations && item.decorations[0])
        setSelectedDecoration(item.decorations[0].id);
      setCurrentItem(rows[0]);
      setupProduct(rows);
    } catch (err) {
      console.error("Failed to update colors", err);
      setLoadError(err?.response?.data?.message || err.message || "Failed to update colors.");
    } finally {
      setColorUpdateSpinner(false);
    }
  }

  const colorImageClick = (item) => {
    setImgSrc(resolveImageUrl(item.frontModelImage));

    setCurrentItem(item);
    setCurrentColor(item.colorName);
    setCurrentSize(0);
    setCurrentPrice(item.sizes[0].price.toLocaleString(undefined, { maximumFractionDigits: 2 }));
    console.log("CLICKED IMAGE");
  }

  const closeImageModal = () => {
    setImageModalShow(false);
  }

  const colorImageOver = (item) => {
    setImgSrc(resolveImageUrl(item.frontModelImage));
    setCurrentColor(item.colorName);
  }

  const colorImageExit = (item) => {
    setImgSrc(resolveImageUrl(currentItem.frontModelImage));
    setCurrentColor(currentItem.colorName);
  }

  const sizeClick = (event) => {
    setCurrentSize(event.target.getAttribute("data"));
    setCurrentPrice(currentItem.sizes[event.target.getAttribute("data")].price.toLocaleString(undefined, { maximumFractionDigits: 2 }));

  }

  useEffect(() => {
    console.log("LOADING PRODUCT");
    let productId = location.state?.productId;
    async function fetchMyAPI() {
      try {
        if (!productId) {
          setLoadError("No product selected.");
          setCatalogItem(null);
          return;
        }
        let item = await ItemService.getItemNonCatalog(productId);
        const rows = Array.isArray(item?.item) ? item.item : [];
        if (!rows[0]) {
          setLoadError("Product not found.");
          setCatalogItem(null);
          return;
        }
        setLoadError(null);
        setCatalogItem(rows);
        setDecorations(item.decorations);
        setQuantityPrices(item.quantityPrices || []);
        if (item.decorations && item.decorations[0])
          setSelectedDecoration(item.decorations[0].id);
        setCurrentItem(rows[0]);
        setupProduct(rows);
      } catch (err) {
        console.error("Failed to load non-catalog product", err);
        setLoadError(err?.response?.data?.message || err.message || "Failed to load product.");
        setCatalogItem(null);
      }
    }

    fetchMyAPI();
  }, []);


  const drop = (item) => {
    console.log("Item Dropped", item);
    setSelectedColors([...selectedColors, item]);
    var i = 0;
    for (i; i < availableColors.length; i++) {
      console.log("IDs", availableColors[i].id, item.id);
      if (availableColors[i].colorName === item.colorName) {
        break;
      }
    }
    availableColors.splice(i, 1);
    setAvailableColors(availableColors);
    console.log("Catalog Item after drop", catalogItem);
  };

  const addAll = () => {
    setSelectedColors([...selectedColors, ...availableColors]);
    setAvailableColors([]);
  };

  const removeAll = () => {
    setAvailableColors([...selectedColors, ...availableColors]);
    setSelectedColors([]);
  };

  const handleSizeCheck = (event) => {
    const target = event.target
    const checked = target.checked
    const label = target.id;
    var sizes = currentDragColorSizes;
    if (checked) sizes.push(label);
    else {
      for (var i = 0; i < sizes.length; i++) {
        if (sizes[i] === label) {
          break;
        }
      }
      sizes.splice(i, 1);
    }
    setCurrentDragColorSizes(sizes);
  };
  const setupProduct = (item) => {
    console.log("ITEM", item);
    if (!item?.[0]?.sizes?.[0]) return;
    price = item[0].sizes[0].price;
    let sizes = new Array();

    let currItem = currentItem ? currentItem : item[0];

    for (var i = 0; i < currItem.sizes.length; i++) {
      if (loginStatus)
        sizes.push(<div><Button key={i} variant="secondary" disabled data={i} onClick={(event) => { sizeClick(event); }}>{currItem.sizes[i].sizeName}<br />${currItem.sizes[i].price.toLocaleString(undefined, { maximumFractionDigits: 2 })}</Button></div>);
      else
        sizes.push(<div><Button key={i} variant="secondary" data={i} onClick={(event) => { sizeClick(event); }}>{currItem.sizes[i].sizeName}</Button></div>);
    }

    setAvailableColors([...item]);
    setImgSrc(resolveImageUrl(currItem.frontModelImage));

  }
  const addColorDrop = (e) => {
    console.log("COLOR DROPPED IN COLOR DIV");
    setCurrentDragColorSizes(new Array());
    console.log(currentDragColor);
    setAddSizes([...addSizes, currentDragColor]);
  };

  const handleAddSizesClick = () => {
    //dispatch(addColor(currentDragColorSizes));
  };

  const removeColorDrop = (e) => {
    console.log("COLOR DROPPED IN REMOVE COLOR DIV");
    console.log(currentDragColor);
  };

  const allowDrop = (e) => {
    e.preventDefault();
  };

  const dragStarted = (item) => {
    setCurrentDragColor(item);
  }

  const addToCatalog = async () => {
    setShowSpinner(true);
    console.log("SELETED DECORATION:", selectedDecoration);
    let item = await CatalogService.addCatalogItem({ items: selectedColors, decorationCode: selectedDecoration });
    setShowSpinner(false);
    navigate("/admin/allcatalog/1");
  }
  let price = 0;

  const editProduct = () => {
    if (!primaryItem?.sizes?.[0]?.productId) return;
    navigate(`/admin/addproduct?productId=${primaryItem.sizes[0].productId}`);
  }

  const removeIgniteProduct = async () => {
    if (!primaryItem) return;
    const styleId = primaryItem.id;
    const title = primaryItem.title || `style #${styleId}`;
    if (!window.confirm(
      `Remove Ignite product "${title}"?\n\n` +
      `If it is in a subsite catalog or on an order it will be soft-deleted; otherwise it will be permanently removed.`
    )) {
      return;
    }
    setRemoving(true);
    setRemoveFlash(null);
    try {
      const result = await CatalogService.deleteIgniteProduct(styleId);
      if (result.softDeleted) {
        navigate('/admin/igniteproducts', {
          state: { flash: { variant: 'warning', message: result.warning } }
        });
      } else {
        navigate('/admin/igniteproducts', {
          state: { flash: { variant: 'success', message: result.message || 'Product permanently removed.' } }
        });
      }
    } catch (err) {
      const msg = err?.response?.data?.message || err.message || 'Failed to remove product';
      setRemoveFlash({ variant: 'danger', message: msg });
    } finally {
      setRemoving(false);
    }
  }

  const loadInventory = async () => {
    setInventoryLoading(true);
    setInventoryMessage(null);
    try {
      const productId = catalogItem[0].sizes[0].productId;
      const result = await AdminService.refreshSandsInventory(productId);
      const r = result && result.data ? result.data : {};
      setInventoryMessage(`Loaded ${r.rowsInserted || 0} warehouse rows for ${r.skuCount || 0} SKUs.`);
    } catch (error) {
      const msg = error && error.response && error.response.data && error.response.data.error
        ? error.response.data.error
        : (error.message || 'Failed to load inventory');
      setInventoryMessage(`Error: ${msg}`);
    } finally {
      setInventoryLoading(false);
    }
  }

  const updateAllDecorations = (decorations) => {
    setCurrentDecorations(decorations);
    if (decorations && decorations.length > 0) {
      setSelectedLogos([decorations[0]]);
      setSelectedDecoration(decorations[0]);
    }
  };

  const updatePrice = (price) => {
    setCurrentLogoPrice(price);
  };

  const setNewDisplayedDecorations = (decos) => {
    // For display purposes
  };

  return (
    <>
    {!primaryItem && !loadError && (<Spinner animation="border" />)}
    {loadError && (
      <Alert variant="danger" style={{ margin: 20 }}>{loadError}</Alert>
    )}
    {primaryItem && (
    <div className="container">
      <div class="product-details-container">
        <div class="product-img-lg">
          {currentItem && currentItem.sizes && currentItem.sizes[0] && (
            <AdminImageGallery
              productId={currentItem.sizes[0].productId}
              displayDecorations={selectedLogos}
              selectedDecoration={selectedDecoration}
              showAdminControls={false}
              forceUpdate={updatedLogos}
              updateAllDecorations={updateAllDecorations}
              updatePrice={updatePrice}
              updateDisplayedDecorations={setNewDisplayedDecorations} />
          )}
          {(!currentItem || !currentItem.sizes || !currentItem.sizes[0]) && (
            <img src={resolveImageUrl(imgSrc)} width={'500'}></img>
          )}
        </div>
        <div class="product-content">
          <div class="title">{primaryItem.title}</div>
          <div>Source: {primaryItem.source}</div>
          {removeFlash && (
            <Alert variant={removeFlash.variant} dismissible onClose={() => setRemoveFlash(null)}>
              {removeFlash.message}
            </Alert>
          )}
          {primaryItem.source === "ignite" && (
            <div className="title" style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <Button onClick={editProduct}>Edit Product</Button>
              {superAdmin && (
                <Button variant="danger" onClick={removeIgniteProduct} disabled={removing}>
                  {removing && <Spinner size="sm" animation="border" />} Remove Product
                </Button>
              )}
            </div>
          )}
          {primaryItem.source === "sands" &&
            <div style={{ margin: '8px 0' }}>
              <Button onClick={loadInventory} disabled={inventoryLoading}>
                {inventoryLoading && <Spinner size="sm" animation="border" />} Load Inventory
              </Button>
              {inventoryMessage && <div style={{ marginTop: 4, fontSize: '0.9em' }}>{inventoryMessage}</div>}
            </div>}
          <div class="description" dangerouslySetInnerHTML={{ __html: primaryItem.htmlDescription ? primaryItem.htmlDescription : primaryItem.description }} />

          {/* Flat pricing (default) */}
          {(!primaryItem.pricingType || primaryItem.pricingType === PRICING_TYPES.FLAT) && primaryItem.sizes?.[0] && (
            <div class="price">${parseFloat(primaryItem.sizes[0].price).toFixed(2)}</div>
          )}

          {/* Quantity pricing */}
          {primaryItem.pricingType === PRICING_TYPES.QUANTITY && (
            <div className="quantity-pricing" style={{ marginBottom: 10 }}>
              <div style={{ fontWeight: 'bold', marginBottom: 5 }}>Quantity Pricing:</div>
              {quantityPrices && quantityPrices.length > 0 ? (
                quantityPrices.map((tier, index) => (
                  <div key={index} style={{ fontSize: '0.9em' }}>
                    {tier.quantity}: ${parseFloat(tier.price).toFixed(2)} each
                  </div>
                ))
              ) : (
                <div style={{ color: '#999', fontStyle: 'italic' }}>No quantity tiers defined</div>
              )}
            </div>
          )}

          {/* Bill later pricing */}
          {primaryItem.pricingType === PRICING_TYPES.BILL_LATER && (
            <div className="price" style={{ color: '#666', fontStyle: 'italic' }}>
              Price: Billed Later
            </div>
          )}
          <div class="color-title">
            Color: {currentColor}
          </div>
          <div class="color-title">
            Selected Colors:
          </div>
          <div class="colors" onDrop={addColorDrop} onDragOver={allowDrop} >
            {selectedColors && selectedColors.map(item => (
              <div class="color-swatch">
                {item.hexColor && item.hexColor != "" && !(item.squareImageName && item.squareImageName != "") && (
                  <div style={{ backgroundColor: item.hexColor, width: 50, height: 50 }}
                    onClick={(event) => colorImageClick(item)}
                    onMouseOver={(event) => colorImageOver(item)}
                    onMouseLeave={() => colorImageExit(item)}
                    onDragEnd={drop}
                    onDragStart={() => dragStarted(item)}
                    key={item.colorName}
                    draggable
                  ></div>
                )}
                {item.squareImageName && item.squareImageName != "" && (
                  <img src={resolveSwatchUrl(item.squareImageName)} height={50}
                    onClick={(event) => colorImageClick(item)}
                    onMouseOver={(event) => colorImageOver(item)}
                    onMouseLeave={() => colorImageExit(item)}
                    onDragEnd={drop}
                    onDragStart={() => dragStarted(item)}
                    key={item.colorName}
                    draggable
                  />

                )}
              </div>
            ))}

          </div>
          <div>
            <Button onClick={addAll}>Add All Colors</Button> &nbsp;
            <Button onClick={removeAll} variant="warning">Remove All Colors</Button>
          </div>
          <div class="color-title">
                Available Colors: <LogoButton style={{ color: "blue" }} size="25" Icon={ArrowClockwise} tooltip="Update Colors from Sanmar" onClick={updateColors} disabled={colorUpdateSpinner} />
                {colorUpdateSpinner && <Spinner size="sm" animation="border" />}
              </div>
          <div class="colors" onDrop={removeColorDrop} onDragOver={allowDrop}>
            {availableColors && availableColors.map(item => (
              <div class="color-swatch">
                {item.hexColor && item.hexColor != "" && !(item.squareImageName && item.squareImageName != "") && (
                  <div style={{ backgroundColor: item.hexColor, width: 50, height: 50 }}
                    onClick={(event) => colorImageClick(item)}
                    onMouseOver={(event) => colorImageOver(item)}
                    onMouseLeave={() => colorImageExit(item)}
                    onDragEnd={() => drop(item)}
                    onDragStart={() => dragStarted(item)}
                    key={item.colorName}
                    draggable

                  ></div>
                )}
                {item.squareImageName && item.squareImageName != "" && (
                  <img src={resolveSwatchUrl(item.squareImageName)} height={50}
                    onClick={(event) => colorImageClick(item)}
                    onMouseOver={(event) => colorImageOver(item)}
                    onMouseLeave={() => colorImageExit(item)}
                    onDragEnd={() => drop(item)}
                    onDragStart={() => dragStarted(item)}
                    key={item.colorName}
                    draggable
                  />
                )}
              </div>
            ))}
          </div>
          <Button onClick={addToCatalog} disabled={showSpinner}>
            {showSpinner && <Spinner size="sm" animation="border" />} Add Product to Catalog
          </Button>
          <br />
          <br />
          <br />
        </div>
      </div>

      <Modal show={show} onHide={handleSizeModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Available Sizes for<br /> {currentDragColor}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {addSizes}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleSizeModalClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAddSizesClick}>
            Add Sizes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>)}
    </>
  );
};
export default ProductDetails;